import React, { useEffect, useState } from "react";

const TermsConditions = () => {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const slug = "terms-conditions"; // MATCH SLUG IN DATABASE

  useEffect(() => {
    fetch(`https://online.funforay.com/admin/api/page/${slug}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setPage(data.data);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching page:", err);
        setLoading(false);
      });
  }, []);

  if (loading) return <p style={{ padding: "20px" }}>Loading...</p>;

  if (!page)
    return (
      <p style={{ padding: "20px", color: "red" }}>
        Page not found or content missing.
      </p>
    );

  return (
    <div className="condition_page">
      
        <section className="contact-banner">
         <h1>{page.title}</h1>
      </section>

      {/* Render HTML content */}
      <div
        className="page-content"
        dangerouslySetInnerHTML={{ __html: page.content }}
      ></div>
    </div>
  );
};

export default TermsConditions;
